StickyHandler = require './sticky_handler'

PURCHASE_CLUSTER_PADDING = 12

StickyPurchaseCluster = window.StickyPurchaseCluster ?= {}

StickyPurchaseCluster.init = (payload, done) ->
  $ ->
    element = $("#purchase-cluster > div")
    container = $('.deal-container')
    new StickyHandler(element, container, PURCHASE_CLUSTER_PADDING)

    done()


module.exports = StickyPurchaseCluster



// WEBPACK FOOTER //
// ./modules/deal/desktop_2016/frontend/sticky_purchase_cluster.coffee